import script from "./technical.vue?vue&type=script&setup=true&lang=ts"
export * from "./technical.vue?vue&type=script&setup=true&lang=ts"

import "./technical.vue?vue&type=style&index=0&id=2d54f1b3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d54f1b3"]])

export default __exports__